import {
  Button,
  Flex,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@ritualco/jutsu'
import 'react-multi-email/style.css'
import * as Yup from 'yup'
import { Form, Formik } from 'formik'
import { FormikMultiEmailInput } from 'components/Formik'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'
import { CompanyInviteFormType, CompanyInviteModalProps } from './types'

const initialValues: CompanyInviteFormType = {
  emails: [],
}

export const CompanyInviteModal = ({
  onSubmit,
  onClose,
  ...modalProps
}: CompanyInviteModalProps) => {
  const { formatMessage } = useContent()
  const FormValueTypeSchema = Yup.object().shape({
    emails: Yup.array(Yup.string().email().required()).min(
      1,
      formatMessage({ id: 'pmportal.settings.team.errors.emails' })
    ),
  })

  return (
    <HeraModal size="2xl" onClose={onClose} {...modalProps}>
      <Formik
        initialValues={initialValues}
        validationSchema={FormValueTypeSchema}
        onSubmit={async (values, actions) => {
          await onSubmit(values.emails)
          actions.setSubmitting(false)
          onClose()
        }}
      >
        {props => (
          <>
            <ModalHeader>
              {formatMessage({ id: 'pmportal.companies.inviteHeading' })}
            </ModalHeader>
            <ModalBody>
              <Form id="companyInvite">
                <Flex direction="column">
                  <Text fontSize="small" color="grayscale.secondary" mb={9}>
                    {formatMessage({
                      id: 'pmportal.companies.inviteDescription',
                    })}
                  </Text>
                  <FormikMultiEmailInput
                    label={formatMessage({
                      id: 'pmportal.companies.emailHeading',
                    })}
                    placeholder={formatMessage({
                      id: 'pmportal.settings.team.emailsPlaceholder',
                    })}
                    name="emails"
                    isRequired
                    {...props}
                  />
                  <Text
                    fontWeight={'thin'}
                    fontSize="xs"
                    color="grayscale.secondary"
                  >
                    {formatMessage({ id: 'pmportal.companies.emailTip' })}
                  </Text>
                </Flex>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="transparent" mr={2} onClick={onClose}>
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="companyInvite"
                isLoading={props.isSubmitting}
              >
                {formatMessage({ id: 'pmportal.companies.sendInvites' })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
